export default "__VITE_ASSET__0c462994__"